import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Button from '../../Shared/Button';
import Footer2 from '../../Shared/Footer2';
import UploadFile from '../../Shared/UploadMultipleFile';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import '../../../css/MarketPlace/ShipmentDetailsTransportationService.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import container from '../../../Assets/ContainerStatus/Assets_Desktop/container.svg';
import deliveryTime from '../../../Assets/NominateRequest/deliveryTime.svg';
import pickupTime from '../../../Assets/NominateRequest/pickupTime.svg';
import offloadTime from '../../../Assets/NominateRequest/offloadTime.svg';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
class ShipmentDetailsTransportationService extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            ContainerNo: 'MRSU3562332',
            HaulageCompany: 'ABC Transport Limited',
            Truck: "ND613690",
            AppointmentSlot: '30-Oct-2020 14:00 - 14:59',
            Destination: "City Centre",
            Requester: 'Mr. Price',
            Location: 'Addington',
            DropOffLocation: '',
            Terminal: 'Cape Town Container Terminal',
            Terminaldropdown: false,
            Terminaldata: [],
            Address: '',
            errors: [],
            filePathCIPC: '',
            uploadedFilesData: [],
            StartTrip: true,
            EndTrip: true,
            CompleteOffload: true,
            TripStartTime: '29-Oct-2020 16:30',
            TripEndTime: '29-Oct-2020 17:04',
            OffloadTime: '29-Oct-2020 17:45',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    Terminaldata = [{ name: "1xyz" }, { name: "2xyz" }, { name: "3xyz" }]
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ Terminaldropdown: false });
        }
    };
    toggleDropdownTerminal = () => {
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
    };
    changeRoleTypeTerminal = (event) => {
        const found = this.Terminaldata.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ Terminal: found.name });
        this.setState({ Terminaldropdown: !this.state.Terminaldropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                Terminal: ''
            }
        });
        document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleStartTrip = () => {
        if (!this.state.EndTrip) {
            this.setState({ CompleteOffload: false });
        }
        if (!this.state.StartTrip) {
            this.setState({ EndTrip: false });
        }
        if (this.state.StartTrip) {
            this.setState({ StartTrip: false })
        }
    }
    handleChangeAddress = (e) => {
        this.setState({ Address: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                Address: ''
            }
        });
        document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.black;
    }
    callbackUploadedFilesFunction = (FilesData) => {
        this.setState({ uploadedFilesData: FilesData });
        console.log("callbackUploadedFilesFunction", this.state.uploadedFilesData);
    }
    uploadFileFun = (uploadConfirm) => {
    }
    setUploadLinkCIPC = (filePathURL) => {
        this.setState({ filePathCIPC: filePathURL })
        console.log("CIPC", filePathURL);
    }
    setLoaderCIPC = (filePathURL) => {
    }
    toggleDropOffLocation = (val) => {
        if (val === "Terminal") {
            this.setState({ DropOffLocation: 'Terminal' })
        }
        if (val === "Address") {
            this.setState({ DropOffLocation: 'Address' })
        }
        this.setState({
            errors: {
                ...this.state.errors,
                DropOffLocation: ''
            }
        });
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (this.state.DropOffLocation === '') {
            formIsValid = false;
            errors["DropOffLocation"] = Message.validation.required;
        }
        if (this.state.DropOffLocation === 'Terminal') {
            if (!this.state.Terminal) {
                formIsValid = false;
                errors["Terminal"] = Message.validation.required;
                document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Terminal')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        if (this.state.DropOffLocation === 'Address') {
            if (!this.state.Address) {
                formIsValid = false;
                errors["Address"] = Message.validation.required;
                document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.red;
            } else {
                document.getElementsByName('Address')[0].style.borderColor = ColorCode.colorCode.black;
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    render() {
        if (this.state.searchPreferredCompanylength > 0) {
            this.state.PreferredCompanydataFound = this.state.PreferredCompanydata.filter(i => i.name.toLowerCase().startsWith(this.state.PreferredCompany.toLowerCase()))
        } else {
            this.state.PreferredCompanydataFound = [];
        }
        return (
            <div class="ShipmentDTSOutercolor">
                <MetaDecorator title={TitleDescription.ShipmentDetailsTransportationServiceTitle} description={TitleDescription.ShipmentDetailsTransportationServiceDescription} />
                <Header tilesFetched={() => { }} />
                <div class="ShipmentDTSOuterDivcss">
                    <div id="ShipmentDTSBoxDiv">
                        <nav class="ShipmentDTSNavbar">
                            <div className="ShipmentDTSNavbarName">
                                <small id="ShipmentDTSNavbarText">Shipment Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="ShipmentDTSMidPartition">
                            <div class="ShipmentDTSMainInsideDiv">
                                <div class="ShipmentDTSInnerHead">
                                    <img src={container} />
                                    <div class="ShipmentDTSHeadText">Container No.</div>
                                    <div class="ShipmentDTSContainernoText">{this.state.ContainerNo}</div>
                                </div>
                                {!this.state.EndTrip &&
                                    <div class="ShipmentDTSDataDiv">
                                        <div class="ShipmentDTSDataInDiv">
                                            <div class="ShipmentDTSDataleftTime">
                                                <img id="ShipmentDTSleftTimeimg" src={pickupTime} />
                                                <text class="ShipmentDTSleftTimeText">Trip Start Time</text>
                                            </div>
                                            <div class="ShipmentDTSDataright">
                                                <text class="ShipmentDTSrightTimeText">{this.state.TripStartTime}</text>
                                            </div>
                                        </div>
                                        <div class="ShipmentDTSDataInDiv">
                                            <div class="ShipmentDTSDataleftTime">
                                                <img id="ShipmentDTSleftTimeimg" src={deliveryTime} />
                                                <text class="ShipmentDTSleftTimeText">Trip End Time</text>
                                            </div>
                                            <div class="ShipmentDTSDataright">
                                                <text class="ShipmentDTSrightTimeText">{this.state.TripEndTime}</text>
                                            </div>
                                        </div>
                                        {!this.state.CompleteOffload &&
                                            <div class="ShipmentDTSDataInDiv">
                                                <div class="ShipmentDTSDataleftTime">
                                                    <img id="ShipmentDTSleftTimeimg" src={offloadTime} />
                                                    <text class="ShipmentDTSleftTimeText">Offload Time</text>
                                                </div>
                                                <div class="ShipmentDTSDataright">
                                                    <text class="ShipmentDTSrightTimeText">{this.state.OffloadTime}</text>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                <div class="ShipmentDTSDataDiv">
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Haulage Company</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText">{this.state.HaulageCompany}</text>
                                        </div>
                                    </div>
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Truck</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText">{this.state.Truck}</text>
                                        </div>
                                    </div>
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Appointment Slot</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText" id="ShipmentDTSrightAppSlotText">{this.state.AppointmentSlot}</text>
                                        </div>
                                    </div>
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Destination</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText">{this.state.Destination}</text>
                                        </div>
                                    </div>
                                </div>
                                <div class="ShipmentDTSDataDiv">
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Requester</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText">{this.state.Requester}</text>
                                        </div>
                                    </div>
                                    <div class="ShipmentDTSDataInDiv">
                                        <div class="ShipmentDTSDataleft">
                                            <text class="ShipmentDTSleftText">Location</text>
                                        </div>
                                        <div class="ShipmentDTSDataright">
                                            <text class="ShipmentDTSrightText">{this.state.Location}</text>
                                        </div>
                                    </div>
                                </div>
                                <div class="ShipmentDTSDataDiv">
                                    {false &&
                                        <div class="ShipmentDTSRadioCardDiv">
                                            <div class="ShipmentDTSDataleft" id="ShipmentDTSDataleftIdMobile">
                                                <text class="ShipmentDTSleftRadioText">Please Select Drop-Off Location</text>
                                            </div>
                                            <div class="ShipmentDTSRadioCard">
                                                <div class="ShipmentDTSRadioDiv">
                                                    <img src={this.state.DropOffLocation === "Terminal" ? selectedRadioButton : defautRadioButton}
                                                        onClick={() => this.toggleDropOffLocation("Terminal")}
                                                    />
                                                    <div class="ShipmentDTSRadioText">Terminal</div>
                                                </div>
                                                <div class="ShipmentDTSRadioDiv">
                                                    <img src={this.state.DropOffLocation === "Address" ? selectedRadioButton : defautRadioButton}
                                                        onClick={() => this.toggleDropOffLocation("Address")}
                                                    />
                                                    <div class="ShipmentDTSRadioText">Address</div>
                                                </div>
                                            </div>
                                            <div className="ShipmentDTSError">{this.state.errors["DropOffLocation"]}</div>
                                            {this.state.DropOffLocation === 'Terminal' &&
                                                <div class="ShipmentDTSterminalInpDiv">
                                                    <small id="ShipmentDTSInpHeading">Terminal</small>
                                                    <div className="pass-wrapper" id="ShipmentDTSInpDiv" >
                                                        <Input
                                                            readOnly name="Terminal" class="input" placeholder="Select Terminal"
                                                            type="text" id="ShipmentDTSInpDropCss" value={this.state.Terminal}
                                                        />
                                                        <div className="ShipmentDTSDropError">{this.state.errors["Terminal"]}</div>
                                                        <i id="ShipmentDTSInp_imgDrop" onClick={this.toggleDropdownTerminal}>
                                                            {this.state.Terminaldropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                                        </i>
                                                    </div>
                                                    {this.state.Terminaldropdown && (
                                                        <div class="ShipmentDTSDropDowmDiv" >
                                                            <div class="ShipmentDTSDropCard" ref={this.container} >
                                                                {(this.Terminaldata.map((name, index) => {
                                                                    return (
                                                                        <DropDownTable onClick={(val) => this.changeRoleTypeTerminal(val)} id="ShipmentDTSDropRowSize">
                                                                            <small class="" id="ShipmentDTSDropRowText" >{name.name} </small>
                                                                        </DropDownTable>
                                                                    );
                                                                }))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                            {this.state.DropOffLocation === 'Address' &&
                                                <div class="ShipmentDTSterminalInpDiv">
                                                    <small id="ShipmentDTSInpHeading">Address</small>
                                                    <div className="pass-wrapper" id="ShipmentDTSInpDiv" >
                                                        <Input
                                                            name="Address"
                                                            class="input" placeholder="Enter Address"
                                                            type="text" id="ShipmentDTSInpCss" value={this.state.Address}
                                                            onChange={this.handleChangeAddress}
                                                        />
                                                        <div className="ShipmentDTSError">{this.state.errors["Address"]}</div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {true &&
                                        <div class="ShipmentDTSDataInDiv">
                                            <div class="ShipmentDTSDataleft">
                                                <text class="ShipmentDTSleftText">Drop-Off Location</text>
                                            </div>
                                            <div class="ShipmentDTSDataright">
                                                <text class="ShipmentDTSrightText">{this.state.Terminal}</text>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {this.state.StartTrip ?
                                    <div class="ShipmentDTSUploadDiv">
                                        <small class="ShipmentDTSUploadText">Upload Container Images (Optional)</small>
                                        <div>
                                            <UploadFile uploaddivid="uploadCIPC" idupload="upload"
                                                name="fileupload"
                                                fileType="jpeg, jpg, png, pdf"
                                                setUploadConfirm={this.uploadFileFun}
                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                setFileLink={this.setUploadLinkCIPC}
                                                setLoader={this.setLoaderCIPC}
                                                ShipmentDetailesCallback={this.callbackUploadedFilesFunction}
                                            />
                                        </div>
                                        <small class="ShipmentDTSUploadBottomText">You can upload maximum 3 images</small>
                                    </div>
                                    :
                                    <div class="ShipmentDTSUploadDiv">
                                        <small class="ShipmentDTSUploadText">Container Images</small>
                                        {(this.state.uploadedFilesData.length > 0) ?
                                            <div class="ShipmentDTSUploadedFiles">
                                                {this.state.uploadedFilesData.map((val, index) => {
                                                    return (
                                                        <>
                                                            <span className="ShipmentuploadedFileSpan">
                                                                <div className="ShipmentuploadedFilename">
                                                                    <div className="ShipmentuploadedFiletext">{val}</div>
                                                                </div>
                                                            </span>
                                                            <hr className="predocspanhr" style={{ display: "flex" }} />
                                                        </>)
                                                })}
                                            </div>
                                            :
                                            <div class="ShipmentDTSEmpthyFies">
                                                <text class="ShipmentDTSEmpthyFiestext">No image Uploaded</text>
                                            </div>
                                        }
                                    </div>
                                }
                                {(!this.state.StartTrip && this.state.EndTrip) && <div class="ShipmentDTSBottomNote">In case of no action, your request will be auto-completed after 7 days.</div>}
                                {this.state.CompleteOffload &&
                                    <div class="ShipmentDTSBtnDiv">
                                        <Button class="ShipmentDTSBtn" onClick={this.handleStartTrip}>
                                            {this.state.StartTrip ?
                                                <small class="caabuttdiv2">Start Trip</small>
                                                :
                                                (this.state.EndTrip ?
                                                    <small class="caabuttdiv2">End Trip</small>
                                                    :
                                                    <small class="caabuttdiv2">Complete Offload</small>
                                                )
                                            }
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ShipmentDTSFooterUnfixed">
                    <Footer />
                </div>
                <div class="ShipmentDTSFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default ShipmentDetailsTransportationService;